import remark from "remark";
import remarkHTML from "remark-html";

export default (value) =>
  remark()
    .use(remarkHTML)
    .processSync(value)
    .toString();
